exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tableSearch[data-v-1c271304]{max-width:200px}", ""]);

// exports
